import { useEffect, useState } from "react"
import { useRouter } from "next/router"

const hasChanged = (a, b) => JSON.stringify(a) !== JSON.stringify(b)

const useUTM = () => {
  const [utmData, setUtmData] = useState({
    utm_source: "",
    utm_campaign: "",
    utm_medium: "",
    utm_content: "",
    utm_term: "",
  })
  const router = useRouter()

  useEffect(() => {
    // Get the current UTM data from the cookie
    const cookieData = {}
    document.cookie.split("; ").forEach(cookie => {
      const [key, value] = cookie.split("=")
      cookieData[key] = decodeURIComponent(value)
    })
    const initialUtmData = {
      utm_source: cookieData.utm_source || "",
      utm_campaign: cookieData.utm_campaign || "",
      utm_medium: cookieData.utm_medium || "",
      utm_content: cookieData.utm_content || "",
      utm_term: cookieData.utm_term || "",
    }

    // Check if the UTM data has changed
    const { utm_source, utm_campaign, utm_medium, utm_content, utm_term } = router.query
    const updatedUtmData = {
      utm_source: utm_source || initialUtmData.utm_source,
      utm_campaign: utm_campaign || initialUtmData.utm_campaign,
      utm_medium: utm_medium || initialUtmData.utm_medium,
      utm_content: utm_content || initialUtmData.utm_content,
      utm_term: utm_term || initialUtmData.utm_term,
    }
    if (hasChanged(initialUtmData, updatedUtmData)) {
      const cookieExpires = new Date()
      cookieExpires.setTime(cookieExpires.getTime() + 30 * 24 * 60 * 60 * 1000) // 30 days
      // Update the UTM data in the cookie
      document.cookie = `utm_source=${encodeURIComponent(
        updatedUtmData.utm_source
      )}; Domain=.pinmed.co; Path=/; Expires=${cookieExpires.toUTCString()}; SameSite=Lax`
      document.cookie = `utm_campaign=${encodeURIComponent(
        updatedUtmData.utm_campaign
      )}; Domain=.pinmed.co; Path=/; Expires=${cookieExpires.toUTCString()}; SameSite=Lax`
      document.cookie = `utm_medium=${encodeURIComponent(
        updatedUtmData.utm_medium
      )}; Domain=.pinmed.co; Path=/; Expires=${cookieExpires.toUTCString()}; SameSite=Lax`
      document.cookie = `utm_content=${encodeURIComponent(
        updatedUtmData.utm_content
      )}; Domain=.pinmed.co; Path=/; Expires=${cookieExpires.toUTCString()}; SameSite=Lax`
      document.cookie = `utm_term=${encodeURIComponent(
        updatedUtmData.utm_term
      )}; Domain=.pinmed.co; Path=/; Expires=${cookieExpires.toUTCString()}; SameSite=Lax`

      // Update the UTM data in the state
      setUtmData(updatedUtmData)
    } else {
      // Use the existing UTM data from the cookie
      setUtmData(initialUtmData)
    }
  }, [router.query])

  return utmData
}

export default useUTM
